import React from 'react';
import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';

import InputWrapper from './InputWrapper';

const StyledTextArea = styled(TextareaAutosize)`
  outline: none;
  border: none;
  flex-grow: 1;
  width: 100%;
  resize: none;
  size: unset;
  font-size: 20px;
  font-family: Roboto;
  background-color: transparent;
  padding: 8px 0;
`;
StyledTextArea.displayName = 'StyledTextArea';

export default class InputArea extends React.Component {
  state = { focused: false };
  handleFocus = () => {
    this.setState({ focused: true });
  };
  handleBlur = () => {
    this.setState({ focused: false });
  };
  render() {
    const { style, label, ...rest } = this.props;
    const { focused } = this.state;
    return (
      <InputWrapper label={label} active={!!rest.value} textArea onClick={this.handleClick} focused={focused} style={style}>
        <StyledTextArea onFocus={this.handleFocus} onBlur={this.handleBlur} { ...rest } />
      </InputWrapper>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Input/InputArea.js